import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['radiusAndShadow'] = {
  boxShadow: themeUi.core.shadow.shadow4,
  backgroundColor: themeUi.semantic.color.background.secondary950
};

export default theme;
